export default {
  meta: {
    title: '客流预估',
  },
};
